import { render, staticRenderFns } from "./GenericAlertDocument.vue?vue&type=template&id=8d759486"
import script from "./GenericAlertDocument.vue?vue&type=script&lang=js"
export * from "./GenericAlertDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports